import { observable, action, runInAction, toJS } from "mobx";
import { getLabel } from "@weapp/utils";
import { Dialog } from "@weapp/ui";
import { accountParams } from './types';
import * as API from "../../api/relogin";
import { getLocationOrigin, isProductEnv, isWeaverOa } from "../../utils";
const { message } = Dialog;

export class ReloginStore {
  // @observable canReload: boolean = true; //限制重登，显示登录跳转
  // @observable statusChecked: boolean = false;//检测完账号状态
  @observable message: string = getLabel('80616', '当前会话已经失效了，请重新登录');
  // @observable tgt: any = null //passport服务器中TGT
  @observable loginParams: accountParams = {
    username: '',
    password: '',
    service: getLocationOrigin()
  }


  @action
  init = () => {
    let username: any = window.TEAMS?.loginAccountInfo?.currentLoginAccount || '';
    // if (isWeaverOa()) {
    //   username = window.TEAMS?.loginAccountInfo?.account || '';
    // }
    this.loginParams.username = username;
  }

  @action
  updateLoginParams = (params: accountParams) => {
    this.loginParams = { ...params };
  }
  // @action
  // checkAccountStatus = async () => {

  //   let { currentUser } = window.TEAMS!;
  //   let username: any = '';
  //   if (currentUser?.loginAccount) {
  //     username = currentUser.loginAccount;
  //   } else if (currentUser?.email) {
  //     username = currentUser.email;
  //   } else if (currentUser.mobile) {
  //     username = currentUser.mobile;
  //   }
  //   this.loginParams.username = username;

  //   //冻结
  //   await API.checkTenantFrezon().then((data: any) => {
  //     if (data && data.frezze) {
  //       runInAction(() => {
  //         this.message = data.message;
  //         this.canReload = false;//不走账号密码登录
  //       })
  //     }
  //   })
  //   //离职
  //   await API.checkEmpAvaliable().then((data: any) => {
  //     if (data && data.unvaliable) {
  //       runInAction(() => {
  //         this.message = data.message;
  //         this.canReload = false;
  //       })
  //     }
  //   });

  //   runInAction(() => {
  //     this.statusChecked = true;
  //   })
  // }

  @action
  relogin = () => {

    let { username, password } = this.loginParams;
    let reg = /^([A-Za-z0-9_\.-]+)@([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,6})$/;
    if (!username || !password) {
      message({
        type: 'error',
        content: getLabel('80618', '用户名或密码不能为空'),
      });
      return;
    }
    if (username.indexOf('@') !== -1) {
      if (!reg.test(username)) {
        message({
          type: 'error',
          content: getLabel('61283', '邮箱格式不正确'),
        });
        return;
      }
    }
    API.getServerTicket(toJS(this.loginParams)).then((data: any) => {
      if (data && data.serviceTicketId) {
        API.initServerTicket(data.serviceTicketId).then((data: any) => {
          if (data && data.succeed) {
            // window.ETEAMSID = data.ETEAMSID;
            //是否需要手工写缓存？
            message({
              type: 'success',
              content: getLabel('80617', '登录成功'),
            });
            if (!isProductEnv()) {
              sessionStorage.removeItem('E10_ETEAMSID');
            }
            const delayTimer = setTimeout(() => {
              // @ts-ignore
              window.location.reload(true);
              clearTimeout(delayTimer)
            }, 1000)
          }
        });
      } else {
        runInAction(() => {
          if (data.data?.errorMsg) {
            this.message = getLabel(data.data.errorMsg.i18nId, data.data.errorMsg.msg);
          }
        })
      }
    })

  }


}
const instance = new ReloginStore();

export default instance;
export type ReloginStoreType = Pick<ReloginStore, keyof ReloginStore>;